/* eslint-disable react/prop-types */

/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.766 18.111h14.4v-4.278h-14.4zM21.6 23h-1.2V11.389c0-1.013.806-1.833 1.8-1.833s1.8.82 1.8 1.833v9.167C24 21.906 22.925 23 21.6 23"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.3 23h17.4v-3.667H3.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.6 23H2.4C1.075 23 0 21.905 0 20.556v-9.167c0-1.013.806-1.833 1.8-1.833s1.8.82 1.8 1.833V23z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.8 1H4.2C2.875 1 1.8 2.095 1.8 3.444v4.89c1.654 0 3 1.37 3 3.055v1.222h14.4V11.39c0-1.685 1.346-3.056 3-3.056V3.444C22.2 2.094 21.125 1 19.8 1"
})), 'CategoryMO');